import { Dispatch } from 'redux';
import { fetchCustomSourceSet } from '../../../../services/discovery/fetchCustomSourceSet';
import { makeFetchModule } from '../../../_utils';
import { storeSourceSets } from '../../entities';

const callbacks = {
    onSuccess: (dispatch: Dispatch, { entities }: { entities: object }) => {
        dispatch(storeSourceSets(entities));
    },
};
const { reducer, fetchData, reset } = makeFetchModule(
    'app/discovery/sourceSetFetching',
    fetchCustomSourceSet,
    callbacks
);

export default reducer;
export { fetchData, reset };
